import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f79c84be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "fas fa-chevron-down"
}
const _hoisted_3 = {
  key: 1,
  class: "fas fa-chevron-right"
}
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "status" }
const _hoisted_6 = {
  key: 0,
  class: "render-values"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "PDF:", -1))
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["render-tab", { open: _ctx.open }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open = !_ctx.open))
    }, [
      _createElementVNode("div", {
        class: "status-bar",
        style: _normalizeStyle({ width: _ctx.width, background: _ctx.color })
      }, null, 4),
      (_ctx.open)
        ? (_openBlock(), _createElementBlock("i", _hoisted_2))
        : _createCommentVNode("", true),
      (!_ctx.open)
        ? (_openBlock(), _createElementBlock("i", _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.queueElement.argumentName), 1),
      _createElementVNode("div", {
        class: "percentage",
        style: _normalizeStyle({ color: _ctx.color })
      }, _toDisplayString(_ctx.percentage) + "%", 5),
      _createElementVNode("div", _hoisted_5, "Status: " + _toDisplayString(_ctx.queueElement.status), 1)
    ], 2),
    (_ctx.open)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.queueElement.status === `complete` && _ctx.target === 'pdf')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.queueElement.views, (view, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createElementVNode("div", null, [
                      _hoisted_8,
                      _createElementVNode("a", {
                        href: view.pdfUrl,
                        target: "_blank"
                      }, _toDisplayString(view.pdfUrl), 9, _hoisted_9)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.queueElement.views, (view, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(view.spreads, (spread, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", null, "Spread: " + _toDisplayString(spread.status), 1),
                      (spread.status === 'complete')
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: spread.url,
                            target: "_blank"
                          }, "link", 8, _hoisted_10))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}